/* ============================================================
   UGOITA Plus 番組詳細ページ：網目の波（mesh wave）背景
   依存ゼロの2D Canvas。点グリッドを正弦波で揺らし、点と線で網目を描く。
   性能：DPR上限1.5 / 30fpsスロットル / 画面外はrAF停止(IntersectionObserver) /
        reduced-motionは静止1フレーム / リサイズ追従。
   色：canvas が継承する --gold を薄いアルファで使用（暗色#0a0a0c上に上品に）。
   使い方：<canvas class="u-prog-mesh" aria-hidden="true"></canvas> を置くだけ。
   ============================================================ */
(function () {
  // 多重読込ガード：LPでは snippets/ugoita-fx-bg.liquid が
  // 「mesh」を選んだセクションの数だけ script を出しうるため（2026-08-20）。
  if (window.UgoitaProgMesh) return;
  window.UgoitaProgMesh = 1;
  function hexToRgb(h) {
    h = String(h || '').trim().replace('#', '');
    if (h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
    if (!/^[0-9a-fA-F]{6}$/.test(h)) h = 'a8842f';
    var n = parseInt(h, 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function init(canvas) {
    if (canvas.dataset.meshInit) return;
    canvas.dataset.meshInit = '1';
    var ctx = canvas.getContext('2d', { alpha: true });
    if (!ctx) return;
    var DPR = Math.min(window.devicePixelRatio || 1, 1.5);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // アクセント色は近傍の .ugoita-program から取得（canvasがbody直下でも拾えるように）
    var host = (canvas.closest && canvas.closest('.ugoita-program')) || document.querySelector('.ugoita-program') || canvas;
    var rgb = hexToRgb(getComputedStyle(host).getPropertyValue('--gold') || '#a8842f');
    var rgbStr = rgb[0] + ',' + rgb[1] + ',' + rgb[2];
    // 濃さの倍率。既定1＝番組ページの従来の見え方。
    // LPはセクション単位＋暗いスクリム越しなので薄すぎて見えず、スニペット側から強めの値を渡す（2026-08-20）。
    var boost = parseFloat(canvas.getAttribute('data-mesh-boost'));
    if (!(boost > 0)) boost = 1;
    // 線は倍率をそのまま、点は控えめ（べき0.45）に効かせる。
    // 同率で上げると点が線の2.4倍目立ち、「網目」ではなく「点の格子」に見えてしまうため。
    var aLine = Math.min(0.15 * boost, 0.62);
    var aDot  = Math.min(0.45 * Math.pow(boost, 0.45), 0.85);
    // 線幅・点径は番組ページと同一（1px / 1.6px）に固定する。
    // boost は「濃さ（アルファ）」だけに効かせる＝太らせない（2026-08-20 ユーザー指摘）。
    var lw    = 1;
    var w = 0, h = 0, cols = 0, rows = 0, SP = 72;
    var raf = null, t0 = 0, last = 0, visible = false;

    function resize() {
      var r = canvas.getBoundingClientRect();
      w = Math.max(1, r.width); h = Math.max(1, r.height);
      SP = w < 768 ? 54 : 74;
      canvas.width = Math.round(w * DPR); canvas.height = Math.round(h * DPR);
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      cols = Math.ceil(w / SP) + 3; rows = Math.ceil(h / SP) + 3;
    }
    function render(ts) {
      var t = ts - t0;
      ctx.clearRect(0, 0, w, h);
      var amp = Math.min(13, SP * 0.2);
      var P = new Array(rows);
      for (var y = 0; y < rows; y++) {
        P[y] = new Array(cols);
        for (var x = 0; x < cols; x++) {
          var bx = x * SP - SP, by = y * SP - SP;
          var dz = Math.sin(bx * 0.012 + t * 0.00042)
                 + Math.cos(by * 0.014 - t * 0.00036)
                 + Math.sin((bx + by) * 0.0085 + t * 0.00028);
          var dx = Math.cos(by * 0.01 + t * 0.0003);
          P[y][x] = { x: bx + dx * amp * 0.5, y: by + dz * amp };
        }
      }
      ctx.lineWidth = lw;
      ctx.strokeStyle = 'rgba(' + rgbStr + ',' + aLine + ')';
      ctx.beginPath();
      for (var y2 = 0; y2 < rows; y2++) {
        for (var x2 = 0; x2 < cols; x2++) {
          var p = P[y2][x2];
          if (x2 < cols - 1) { var rp = P[y2][x2 + 1]; ctx.moveTo(p.x, p.y); ctx.lineTo(rp.x, rp.y); }
          if (y2 < rows - 1) { var dp = P[y2 + 1][x2]; ctx.moveTo(p.x, p.y); ctx.lineTo(dp.x, dp.y); }
        }
      }
      ctx.stroke();
      ctx.fillStyle = 'rgba(' + rgbStr + ',' + aDot + ')';
      for (var y3 = 0; y3 < rows; y3++)
        for (var x3 = 0; x3 < cols; x3++) { var q = P[y3][x3]; var ds = 1.6; ctx.fillRect(q.x - ds / 2, q.y - ds / 2, ds, ds); }
    }
    function loop(ts) {
      if (!t0) t0 = ts;
      if (ts - last >= 33) { last = ts; render(ts); }   // ~30fps
      if (visible && !reduce) raf = requestAnimationFrame(loop);
    }
    function nowMs() { return (window.performance && performance.now) ? performance.now() : Date.now(); }
    function start() {
      if (raf) return;
      if (reduce) { render(nowMs()); return; }   // reduced-motion は静止1フレーム
      raf = requestAnimationFrame(loop);
    }
    function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } }

    resize();
    if ('ResizeObserver' in window) new ResizeObserver(function () { resize(); if (reduce || !raf) render(last || nowMs()); }).observe(canvas);
    else window.addEventListener('resize', function () { resize(); if (reduce || !raf) render(last || nowMs()); });

    // 固定フルビューポートcanvasは常に画面内 → 即時開始。省電力はタブ非表示で停止。
    visible = true;
    start();
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else { t0 = 0; last = 0; start(); }
    });
  }
  function boot() {
    // マーカー [data-ugoita-prog-mesh] があり、まだcanvasが無ければ body 直下に生成
    // （Shopifyのセクション入れ子による stacking/clip を避け、固定ビューポート背景にする）
    var marker = document.querySelector('[data-ugoita-prog-mesh]');
    if (marker && !document.querySelector('canvas.u-prog-mesh') && document.body) {
      var cv = document.createElement('canvas');
      cv.className = 'u-prog-mesh';
      cv.setAttribute('aria-hidden', 'true');
      // 濃さの指定はマーカー側に書く（canvasはここで初めて生成されるため）。2026-08-21
      var mb = marker.getAttribute('data-mesh-boost');
      if (mb) cv.setAttribute('data-mesh-boost', mb);
      document.body.insertBefore(cv, document.body.firstChild);
      document.documentElement.classList.add('u-prog-mesh-on'); // CSS: セクション透過を有効化
    }
    var list = document.querySelectorAll('canvas.u-prog-mesh');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
